<template>
    <div id="voucherDetailsWrapper">
        <media-only desktop>
            <USPBanner v-if="uspBannerVisible"/>
        </media-only>

        <component
            :is="component"
            v-bind="{
                //unification
                product: voucher,
                //unification
                productDetails: voucherDetails,
                relatedProducts,
                teaser,
                hotelDetails: voucherProviderDetails,
                extraServicesAndInfos: []
            }"
        />
    </div>
</template>

<script>
import ProductDetailsDesktop from '@/components/product/ProductDetailsDesktop';
import ProductDetailsMobile from '@/components/product/ProductDetailsMobile';
import Grid from '@/models/Grid';
import getHead from '@/mixins/getHead';
import extraScriptCode from '@/mixins/extraScriptCode';
import advertisable from '@/mixins/advertisable';
import fetchResource from '@/utils/fetchResource';
import constructProductSchema from '@/utils/constructProductSchema';

export default {
    name: 'VoucherDetails',
    layout: ({layout}) => layout,
    mixins: [getHead, extraScriptCode('voucher'), advertisable('voucher')],
    async fetch(context) {
        await fetchResource(context, context.store.dispatch('getVoucher', context.params.valueVoucherId));
    },
    components: {
        ProductDetailsDesktop,
        ProductDetailsMobile,
        NettoProductDetails: () =>
            import(
                /* webpackChunkName: "netto-product-details" */ '@/themes/nettovorteilswelt/components/product/NettoVoucherDetails'
                )
    },
    head() {
        return this.getHead(
            {
                pageTitle: this.voucher.metaTitle,
                noindex: this.voucher.noindex,
                keywords: this.voucher.metaKeywords,
                metaDescription: this.voucher.metaDescription,
                canonicalUrl: this.voucher.canonicalUrl
            },
            this.schemaOrg
        );
    },
    data() {
        if (this.$store.state.theme === 'kurzinurlaub') {
            return {
                voucherProviderDetails: {
                    provider: 'Kurz-in-Urlaub / Animod GmbH',
                    street: 'Holzdamm 40',
                    zipcode: '20099',
                    city: 'Hamburg'
                }
            };
        }
        return {
            voucherProviderDetails: {
                provider: 'Animod GmbH',
                street: 'Bayenthalgürtel 4',
                zipcode: '50968',
                city: 'Köln'
            }
        };
    },
    computed: {
        schemaOrg() {
            return constructProductSchema(this.voucher, this.voucherDetails.productCategory);
        },
        component() {
            if (this.$store.state.theme === 'nettovorteilswelt') {
                return 'NettoProductDetails';
            }
            if (this.$root.isMobile) {
                return 'ProductDetailsMobile';
            }
            return 'ProductDetailsDesktop';
        },
        voucher() {
            return this.$store.state.product;
        },
        voucherDetails() {
            const details = this.voucher.voucherDetails || {};

            return {
                ...details,
                variants: details.variants.map(variant => ({
                    ...variant,
                    selectionText: details.selectionText || details.type
                }))
            };
        },
        teaser() {
            //now for desktop. For mobile teaser should be combined with images
            const {teaserImageUrl} = this.voucherDetails;
            return {imageUrl: teaserImageUrl};
        },
        relatedProducts() {
            return new Grid(this.$t('ProductDetails.relatedOffers.header'), this.voucher.relatedProducts);
        }
    },
    methods: {
        sendGTMEvent() {
            this.$gtm && this.voucherDetails && this.$gtm.pushValueVoucherDetailsData(this.voucherDetails);
        }
    },
    beforeMount() {
        this.sendGTMEvent();
    }
};
</script>
